import { AuthLibMode, AuthLibSettings, getAccessToken as getToken } from '@mamdev/fd.libs.oauth2-client'
import * as logger from '@mamdev/navigator.frontend-logger'
import { getMonitoringService } from './monitoring'

export async function getAccessToken(config: AuthLibSettings): Promise<string> {
  try {
    if (config.mode === AuthLibMode.STANDALONE) {
      // standalone mode navigates away
      getMonitoringService()?.flush()
    }

    const token =  await getToken(config)
    getMonitoringService()?.monitorTokenCreationSuccess(config.mode)

    return token

  } catch (e) {
    if (e?.message?.toLowerCase().indexOf('redirecting') !== -1) {
      logger.debug(e.message)
      return null
    } else {
      getMonitoringService()?.monitorTokenCreationFailure(config.mode)

      throw e
    }
  }
}
